<ngx-content-loading
  *ngIf="isAppRunningInBrowser"
  xmlns:svg="http://www.w3.org/2000/svg"
  [width]="width"
  [height]="height"
  [style.width]="'100%'"
  [style.height]="'100%'"
  [primaryColor]="'#271A3B'"
  [secondaryColor]="'#3B275A'"
  [class.full-sized]="useDynamicFullSize"
>
  <svg:g
    ngx-rect
    [width]="useDynamicFullSize ? dynamicWidth : width"
    [height]="useDynamicFullSize ? dynamicHeight : height"
    y="0"
    x="0"
  ></svg:g>
</ngx-content-loading>

<div *ngIf="!isAppRunningInBrowser" class="loading-item"></div>
